import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";

export const ContingentLiabilitiesFlow = () => {
  return (
    <div className="body-bg py-5">
      <Container>
        <h2 className="step-head-gray pulse text-center py-3">Are you a guarantor on any leases or other obligations?</h2>
        <Row className="py-5 justify-content-md-center">
          <Col xs={3}>
            <Link to="/dashboard/contingent-liabilities">
              <button className="cl-btn-blue big">Yes, I am</button>
            </Link>
          </Col>
          <Col xs={3}>
            <Link to="/dashboard/contingent-liabilities-questionnaire">
              <button className="cl-btn-gray big">No, I'm not</button>
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
